import { FrameProviderFramerV3 } from "./utils/framer_v3/frameprovider";
import { RoutesProvider } from "./utils/framer_v3/routesprovider";
import { GeohashGeometryProvider } from "./GeohashGeometryProvider";
import { ICoreNodeWrapperBase, IFillNodeWrapperBase, IFullNodeWrapperBase, Infra3DDataProviderBase, UtilsBase, } from "./Infra3DDataProviderBase";
import { CampaignProvider } from "./utils/framer_v3/campaignprovider";
// TODO: Sort and structure all import of mapillary code.
// TODO: Option guards.
// TODO: Once in infra3dsdk, really think about frame props, capturesystem and framedatameta.
// Geoframe vs MeasureInfo.
// TODO: Remove more that is not needed.
// TODO: Typesafer IO
// TODO: Options of viewer need to be asserted at one place.
class Utils extends UtilsBase {
    static coreImages(frames) {
        const res = {};
        for (const frame of frames) {
            res[frame.key] = new ICoreNodeWrapperV3(frame);
        }
        return res;
    }
    static fillImages(frames) {
        const res = {};
        for (const frame of frames) {
            res[frame.key] = new IFillNodeWrapperV3(frame);
        }
        return res;
    }
    static fullImages(frames) {
        const res = {};
        for (const frame of frames) {
            res[frame.key] = new IFullNodeWrapperV3(frame);
        }
        return res;
    }
}
export class ICoreNodeWrapperV3 extends ICoreNodeWrapperBase {
    constructor(frame) {
        super(frame);
        this.frame = frame;
    }
    get sequence_key() {
        return String(`${this.frame.collection}/${this.frame.segment}`);
    }
}
export class IFillNodeWrapperV3 extends IFillNodeWrapperBase {
    constructor(frame) {
        super(frame);
        this.frame = frame;
    }
    get captured_with_camera_uuid() {
        return this.frame.capturesystem.id;
    }
}
export class IFullNodeWrapperV3 extends IFullNodeWrapperBase {
    constructor(frame) {
        super();
        this.iCoreNodeWrapper = new ICoreNodeWrapperV3(frame);
        this.iFillNodeWrapper = new IFillNodeWrapperV3(frame);
    }
}
export class Infra3DDataProvider extends Infra3DDataProviderBase {
    constructor(options, authObject, lidarprovideroptions, projectScope, geometry) {
        super(options, authObject, projectScope, lidarprovideroptions, geometry ? geometry : new GeohashGeometryProvider(options.collection));
        this.frameProvider = new FrameProviderFramerV3(options.host, authObject, projectScope);
        this.routesProvider = new RoutesProvider(options.host, authObject, projectScope);
        this.campaignProvider = new CampaignProvider(options.host, authObject, projectScope);
        this.collection = options.collection;
        this.framer_version = "3";
    }
    getCoreImages(cellId) {
        const corners = UtilsBase.cornersProjectedTo(this._geometry.getCorners(cellId));
        return new Promise((resolve, reject) => {
            function handleSuccess(frames) {
                resolve({ [cellId]: Utils.coreImages(frames) });
            }
            function handleError(error) {
                reject(error);
            }
            this.frameProvider.allWithin(this.collection, corners.sw.lon, corners.se.lon, corners.se.lat, corners.ne.lat, 4326, handleSuccess, handleError);
        });
    }
    getFillImages(imageKeys) {
        return new Promise((resolve, reject) => {
            let count = imageKeys.length;
            const res = [];
            function handleSuccess(frame) {
                count = count - 1;
                res.push(frame);
                if (count === 0) {
                    resolve(Utils.fillImages(res));
                }
            }
            function handleError(error) {
                reject(error);
            }
            for (const imageKey of imageKeys) {
                this.frameProvider.get(this.collection, imageKey, handleSuccess, handleError);
            }
        });
    }
    getFullImages(imageKeys) {
        return new Promise((resolve, reject) => {
            let count = imageKeys.length;
            const res = [];
            function handleSuccess(frame) {
                count = count - 1;
                res.push(frame);
                if (count === 0) {
                    resolve(Utils.fullImages(res));
                }
            }
            function handleError(error) {
                reject(error);
            }
            for (const imageKey of imageKeys) {
                this.frameProvider.get(this.collection, imageKey, handleSuccess, handleError);
            }
        });
    }
    getRoutes(options) {
        options.epsg = options.epsg || 4326;
        return new Promise((resolve, reject) => {
            this.routesProvider.allRoutes(this.collection, options.minEasting, options.maxEasting, options.minNorthing, options.maxNorthing, options.epsg, (geojson) => {
                resolve(geojson);
            }, (error) => {
                reject(error);
            });
        });
    }
    getRouteLines(options) {
        options.epsg = options.epsg || 4326;
        return new Promise((resolve, reject) => {
            this.routesProvider.allRouteLines(options.loa, this.collection, options.minEasting, options.maxEasting, options.minNorthing, options.maxNorthing, options.epsg, (geojson) => {
                resolve(geojson);
            }, (error) => {
                reject(error);
            });
        });
    }
    getRouteHexes(options) {
        options.epsg = options.epsg || 4326;
        return new Promise((resolve, reject) => {
            this.routesProvider.allRouteHexes(options.loa, this.collection, options.minEasting, options.maxEasting, options.minNorthing, options.maxNorthing, options.epsg, (geojson) => {
                resolve(geojson);
            }, (error) => {
                reject(error);
            });
        });
    }
    getLidarFragments(options) {
        options.epsg = options.epsg || 4326;
        return new Promise((resolve, reject) => {
            this.lidarProvider.allLidarFragments(this.collection, options.minEasting, options.maxEasting, options.minNorthing, options.maxNorthing, options.epsg, (geojson) => {
                resolve(geojson);
            }, (error) => {
                reject(error);
            });
        });
    }
    getLidarFragmentLines(options) {
        options.epsg = options.epsg || 4326;
        return new Promise((resolve, reject) => {
            this.lidarProvider.allLidarFragmentLines(options.loa, this.collection, options.minEasting, options.maxEasting, options.minNorthing, options.maxNorthing, options.epsg, (geojson) => {
                resolve(geojson);
            }, (error) => {
                reject(error);
            });
        });
    }
    getLidarFragmentHexes(options) {
        options.epsg = options.epsg || 4326;
        return new Promise((resolve, reject) => {
            this.lidarProvider.allLidarFragmentHexes(options.loa, this.collection, options.minEasting, options.maxEasting, options.minNorthing, options.maxNorthing, options.epsg, (geojson) => {
                resolve(geojson);
            }, (error) => {
                reject(error);
            });
        });
    }
    findNearest(easting, northing, epsg) {
        return new Promise((resolve, reject) => {
            function handleError(error) {
                reject(error);
            }
            this.frameProvider.findNearest(this.collection, easting, northing, epsg, (frames) => {
                if (frames.length > 0) {
                    resolve(Utils.fullImages(frames)[frames[0].id]);
                }
                else {
                    handleError("No frame found");
                }
            }, handleError);
        });
    }
    set authObject(authObject) {
        this.frameProvider.authObject = authObject;
        this.routesProvider.authObject = authObject;
    }
    getAllCampaigns(bbox) {
        return new Promise((resolve, reject) => {
            this.campaignProvider.allCampaigns(this.collection, (campaigns) => {
                resolve(campaigns);
            }, (error) => {
                reject(error);
            }, bbox);
        });
    }
    getCampaign(uid) {
        return new Promise((resolve, reject) => {
            this.campaignProvider.getCampaign(this.collection, uid, (campaign) => {
                resolve(campaign);
            }, (error) => {
                reject(error);
            });
        });
    }
}
//# sourceMappingURL=Infra3DDataProvider_v3.js.map